import { type FunctionComponent, } from "react";
import { Alchemy } from "./Alchemy";
import { Arbitrum, } from "./Arbitrum";
import { BinanceLabs, } from "./BinanceLabs";
import { ChainLink, } from "./ChainLink";
import { TheGraph, } from "./TheGraph";

export declare type PartnerName = "arbitrum" | "binancelabs" | "thegraph" | "alchemy" | "chainLink";

export const icons: Map<PartnerName, FunctionComponent> = new Map();
icons.set("alchemy", Alchemy);
icons.set("arbitrum", Arbitrum);
icons.set("binancelabs", BinanceLabs);
icons.set("chainLink", ChainLink);
icons.set("thegraph", TheGraph);